import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=6c9a90a1&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=6c9a90a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a90a1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Container: require('/vercel/path0/components/ui/Container.vue').default})
